import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const LoadingTaskRow = ({ classes }) => (
  <TableRow className={classes.row}>
    <TableCell>
      <Skeleton
        variant="text"
        width={75}
        height={50}
      />
    </TableCell>
    <TableCell><Skeleton
      variant="text"
      width={85}
      height={30}
      sx={{
        display: 'table-cell',
        mr: 1,
      }}
    /><Skeleton variant="text" width={75} height={30} sx={{ display: 'table-cell' }} />
    </TableCell>
    <TableCell>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="circular" width={45} height={45} sx={{ marginRight: 1 }} />
        <Skeleton
          variant="text"
          width={50}
          height={50}
          sx={{
            color: 'action.active',
            mr: 1,
            my: 0.5,
          }}
        />
      </Box>
    </TableCell>
    <TableCell><Skeleton variant="text" width={100} height={30} /></TableCell>
    <TableCell><Skeleton variant="text" width={60} height={30} /></TableCell>
    <TableCell><Skeleton variant="text" width={60} height={30} /></TableCell>
  </TableRow>
);

LoadingTaskRow.propTypes = { classes: PropTypes.object };

LoadingTaskRow.defaultProps = { classes: {} };

export default LoadingTaskRow;
